import React from "react";
import ButtonOrang from "./ButtonOrang";
import videoPlaceholder from "../assets/images/sidom/fotos/bg-default (2).jpg";

export default function HeroComexButton({
  titulo,
  subtitulo,
  imagen,
  video,
  texto,
  height = "h-[460px]",
  buttonText,
  buttonLink,
}) {
  const urlApi = process.env.REACT_APP_STRAPI_URL;

  return (
    <section
      className={`relative w-full ${height} flex items-center justify-center overflow-hidden`}
    >
      <div className="">
        {/* Imagen de fondo por defecto */}
        <img
          src={videoPlaceholder}
          alt="Fondo por defecto"
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
          draggable={false}
        />
        {video ? (
          <video
            className="absolute top-0 left-0 w-full h-full object-cover z-0"
            autoPlay
            playsInline
            loop
            muted
            style={{ zIndex: 1 }}
          >
            <source src={`${urlApi}${video}`} type="video/mp4" />
          </video>
        ) : (
          <img
            src={`${urlApi}${imagen}`}
            alt="Puerto y autos Comex"
            className="absolute top-0 left-0 w-full h-screen object-cover z-0"
            draggable={false}
            style={{ zIndex: 1 }}
          />
        )}
        {/* Overlay oscuro */}
        <div className="absolute top-0 left-0 w-full h-full bg-sidom-blue/50 z-10" />

        <div className="container line-clamp-1   mt-20 z-20 w-full flex flex-col items-center justify-center px-2">
          {Array.isArray(texto) &&
            texto.map((bloque, idx) => {
              // Renderizar headings dinámicos
              if (bloque.type === "heading" && Array.isArray(bloque.children)) {
                const headingLevel =
                  typeof bloque.level === "number" ? bloque.level : 2;
                const HeadingTag = `h${headingLevel}`;
                const headingClass =
                  headingLevel === 1
                    ? "text-3xl sm:text-4xl md:5x1 mt-0 sm:mt-5 md:mt-7 lg:mt-5 xl:mt-0   lg:text-6xl"
                    : headingLevel === 2
                    ? "text-xl sm:text-3xl md text-4xl"
                    : headingLevel === 3
                    ? "text-lg sm:text-xl md:text-2xl"
                    : "";
                return React.createElement(
                  HeadingTag,
                  {
                    key: idx,
                    className: `text-sidom-light font-extrabold text-center mb-5 drop-shadow-lg ${headingClass}`,
                  },
                  bloque.children.map((child, i) => {
                    if (child.bold && child.italic) {
                      return (
                        <strong key={i}>
                          <em>{child.text}</em>
                        </strong>
                      );
                    } else if (child.bold) {
                      return <strong key={i}>{child.text}</strong>;
                    } else if (child.italic) {
                      return <em key={i}>{child.text}</em>;
                    } else {
                      return <span key={i}>{child.text}</span>;
                    }
                  })
                );
              }
              // Renderizar párrafos dinámicos
              if (
                bloque.type === "paragraph" &&
                Array.isArray(bloque.children)
              ) {
                return (
                  <p
                    key={idx}
                    className="text-sidom-light text-xl sm:text-3xl md:text-4xl font-extrabold text-center mb-5 drop-shadow-lg"
                  >
                    {bloque.children.map((child, i) => {
                      if (
                        child.type === "link" &&
                        child.url &&
                        Array.isArray(child.children)
                      ) {
                        return (
                          <a
                            key={i}
                            href={child.url}
                            className="text-sidom-orange underline hover:text-sidom-orange/70"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {child.children.map((subChild, j) => {
                              if (subChild.bold && subChild.italic) {
                                return (
                                  <strong key={j}>
                                    <em>{subChild.text}</em>
                                  </strong>
                                );
                              } else if (subChild.bold) {
                                return <strong key={j}>{subChild.text}</strong>;
                              } else if (subChild.italic) {
                                return <em key={j}>{subChild.text}</em>;
                              } else {
                                return <span key={j}>{subChild.text}</span>;
                              }
                            })}
                          </a>
                        );
                      }
                      if (child.bold && child.italic) {
                        return (
                          <strong key={i}>
                            <em>{child.text}</em>
                          </strong>
                        );
                      } else if (child.bold) {
                        return <strong key={i}>{child.text}</strong>;
                      } else if (child.italic) {
                        return <em key={i}>{child.text}</em>;
                      } else {
                        return <span key={i}>{child.text}</span>;
                      }
                    })}
                  </p>
                );
              }
              return null;
            })}
          {buttonText && <ButtonOrang text={buttonText} link={buttonLink} />}
        </div>
      </div>
    </section>
  );
}
